import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  padding: 16px 0;
  width: 100%;

  /* Tablet: 2 colunas balanceadas */
  @media screen and (min-width: 600px) and (max-width: 950px) {
    grid-template-columns: 1fr 1fr;
  }

  /* Desktop: 2 colunas com proporção otimizada */
  @media screen and (min-width: 951px) {
    grid-template-columns: 45fr 55fr;
  }
`;

export const HistorySection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0; /* Previne overflow em grid */
  max-height: 580px; /* Altura máxima para scroll */
  overflow-y: auto;

  /* Mobile: ordem primeiro */
  order: 1;

  /* Desktop: mantém na esquerda */
  @media screen and (min-width: 600px) {
    order: 1;
  }

  /* Override do width fixo do InspectionSteps para responsividade */
  > div {
    width: 100% !important;
    max-width: 100%;
    padding: 16px 20px !important; /* Reduzir padding lateral */
    gap: 16px !important;
  }

  /* Scroll suave e scrollbar customizada */
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bcc4d2;
    border-radius: 3px;

    &:hover {
      background: #6a758b;
    }
  }

  @media screen and (max-width: 599px) {
    max-height: 450px;

    > div {
      padding: 16px !important;
    }
  }
`;

export const CommentsSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0; /* Previne overflow em grid */
  min-height: 350px;

  /* Mobile: ordem segundo (abaixo do histórico) */
  order: 2;

  /* Desktop: mantém na direita */
  @media screen and (min-width: 600px) {
    order: 2;
  }

  @media screen and (max-width: 599px) {
    min-height: 280px;
  }
`;

export const Divider = styled.hr`
  display: block;
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0;
  grid-column: 1 / -1; /* Ocupa todas as colunas */

  /* Esconde divider em desktop (não necessário com colunas) */
  @media screen and (min-width: 600px) {
    display: none;
  }
`;
